import React from "react";
import Fade from './Fade.js';
 


export class WidgetTemplateTg extends React.Component {

    initialState = {
        showFirstStage : true,
        showSecondStage : !true,
        showThirdStage : !true,
        showFourthStage : !true,
        animationEnded : true
    }
    state = this.initialState

    constructor(props) {
        super(props);
        this.refFirstStage = React.createRef();
        this.refSecondStage = React.createRef();
        this.refThirdStage = React.createRef();
    }

    resetState() {
        this.setState(this.initialState)
    }

    showSecondStage(e) {
        return;
        
        e.preventDefault()
        
        //alert(1)
       
        this.refFirstStage.current.classList.add('fade-out')
        
        

    }

    showSecondStageAnimationEnd() {
        if (this.state.showFirstStage && this.state.animationEnded) {
            this.setState((prevState) => {
                return  {
                       ...prevState,
                       showFirstStage : false,
                       showSecondStage : true,
                       animationEnded : false
                       
                   
                   };
           }, () =>  {
               
           })
        }
        
    }

    showThirdStage(e) {
        
        
        e.preventDefault()
        //alert(1)
        this.refSecondStage.current.classList.add('fade-out')
        
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   
                   animationEnded : true
                   
               
               };
       }, () =>  {
           
       })

       
           

        

    }
    
    showThirdStageAnimationEnd() {
        if (this.state.showSecondStage && this.state.animationEnded) {
            this.setState((prevState) => {
                return  {
                       ...prevState,
                       showSecondStage : false,
                       showThirdStage : true,
                       animationEnded : false
                       
                   
                   };
           }, () =>  {
               
           })
        }
        
    }


    showFourthStage(e) {
        e.preventDefault()
        this.refThirdStage.current.classList.add('fade-out')
        
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   
                   animationEnded : true
                   
               
               };
       }, () =>  {
           
       })
    }

    transformSpaces(a) {

        var b = '\u00a0'
        var l = ['из-за', 'чтобы']
        var new_sentence = ''
        var words = a.split(' ')
        var word;
        for (var i=0; i<words.length; i++) {
            word =  words[i]
            if (word.length <= 3 || (l.indexOf(word) > -1)) {
                new_sentence += word + b
            }
            else {
                new_sentence += word + ' '
            }
            
        }
        new_sentence = new_sentence.replace('-', '\u2011')
        
       return new_sentence
    }
       
        

    showFourthStageAnimationEnd() {
        if (this.state.showThirdStage && this.state.animationEnded) {
            this.setState((prevState) => {
                return  {
                       ...prevState,
                       showThirdStage : false,
                       showFourthStage : true,
                       animationEnded : false
                       
                   
                   };
           }, () =>  {
               
           })
        }
        
    }

   

    render() {
        return (
            <div className="reset-this">
            <div className={ 
             this.props.show   ? 
            "WidgetTemplate_bodyBackground " 
            :
             "WidgetTemplate_bodyBackground hidden"}></div>
            <div className={ 
             this.props.show   ? 
            "WidgetTemplate_widget" 
            :
             "WidgetTemplate_widget hidden"}>    
                <div className="WidgetTemplate_widget_inner">
                 
                    <img onClick={(e) => {
                        this.resetState() 
                        this.props.setShowPreview(e, !true)
                    }
                    } id="doClose" className="WidgetTemplate_widgetCloseIcon" src="https://clientsaver.ru/static/css/close-icon.svg" />
                    <img 
                    onClick={(e) => {
                        this.resetState() 
                        this.props.setShowPreview(e, !true)
                    }}
                    className='WidgetTemplate_widgetCloseIcon WidgetTemplate_widgetCloseIcon_mobile' 
                    src='https://clientsaver.ru/static/css/close-icon-mobile.svg' />
                <div  className='WidgetTemplate_rightSide'>
                    <img  className='WidgetTemplate_desktopImage' src={this.props.big_img_src} />
                    <img  className="WidgetTemplate_mobileImage" src={this.props.small_img_src} />
                </div>
                <div  className='WidgetTemplate_leftSide'>
                    <div  className='WidgetTemplate_leftSide_inner'>
                    <div className="WidgetTemplate_leftSide_mainBlock">
                        
                            <div ref={this.refFirstStage} className={
                                this.state.showFirstStage 
                                ?
                                 "WidgetTemplate_firstStage" 
                                 :
                                  "WidgetTemplate_firstStage hidden" 
                            } 
                            onAnimationEnd={ () => {
                                this.showSecondStageAnimationEnd() 
                            }
                            }
                            >
                                <h1>{this.transformSpaces(this.props.header_text)}</h1>
                                <h2> {this.transformSpaces(this.props.main_text)}</h2>                    
                                <div  className='WidgetTemplate_buttonBlock'> 
                                <a onClick={(e)=>{
                                    this.showSecondStage(e)
                                }} href='#' className="WidgetTemplate_firstStageButton" > Получить</a>
                                </div>
                                <div className="WidgetTemplate_poweredByBlock">
                                    Создано на <a href="#">clientsaver</a>
                                </div>
                            </div>
                        
                        
                        
                            <div ref={this.refSecondStage} className={
                                this.state.showSecondStage 
                                ?
                                "WidgetTemplate_secondStage WidgetTemplate_preview_secondStage fade-in" 
                                :
                                "WidgetTemplate_secondStage" 
                            }
                            onAnimationEnd={ () => {
                                this.showThirdStageAnimationEnd() 
                            }}>
                                <h1> Оформите подписку и получите подарок!</h1>
                                <h2> Введите свой логин телеграм, чтобы мы могли проверить подписку </h2> 
                                                
                                <div  className='WidgetTemplate_divInput'> 
                                @ <input id='username' type="text" />
                                </div>
                                <div  className='WidgetTemplate_buttonBlock'>                                                
                                    <a  onClick={(e)=>{
                                    this.showThirdStage(e)
                                }}  href='#'  className="WidgetTemplate_secondStageButton" > Далее</a>
                                </div>
                                <div className="WidgetTemplate_poweredByBlock"> 
                                Создано на <a href="#">clientsaver</a>
                                </div>                    
                            </div>
                        
                        
                            <div ref={this.refThirdStage} className={
                                this.state.showThirdStage 
                                ?
                                "WidgetTemplate_thirdStage WidgetTemplate_preview_thirdStage fade-in" 
                                :
                                "WidgetTemplate_thirdStage" 
                            }
                            onAnimationEnd={ () => {
                                this.showFourthStageAnimationEnd() 
                            }}>
                                <h1> Теперь перейдите в наш канал и подпишитесь!</h1>      
                                <h2> Не забудьте вернуться на эту страницу для получения приза </h2>
                                <div className="WidgetTemplate_linkToTgBlock"> 
                                    <a target="_blank" href={this.props.tg_link} >  
                                        Нажмите сюда, чтобы перейти в телеграм канал
                                    </a>
                                </div>
                                <div  className='WidgetTemplate_buttonBlock'>
                                    <a onClick={(e) => {
                                        this.showFourthStage(e) }} href='#'  className="WidgetTemplate_thirdStageButton">  
                                        Подписка оформлена! 
                                    </a>
                                </div>
                                <div className="WidgetTemplate_poweredByBlock"> 
                                Создано на <a href="#">clientsaver</a>
                                </div> 
                            </div>
                         
                        
                            <div className={
                                this.state.showFourthStage 
                                ?
                                "WidgetTemplate_fourthStage WidgetTemplate_preview_fourthStage fade-in" 
                                :
                                "WidgetTemplate_fourthStage" 
                            }
                            >
                                <h1> Спасибо за подписку!</h1>
                                <h2  dangerouslySetInnerHTML={{__html: 
                                    this.props.transormLinks(this.props.prize) }} />   
                                <div className="WidgetTemplate_poweredByBlock">
                                    Создано на <a href="#">clientsaver</a>
                                </div>
                            </div>
                                       
                    </div>            
                    </div>        
                    </div>   
                     </div>
                     </div>
                      </div>
        )
    }
}

